/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PROAUTH", "88")




export interface API45655Req {
  
  /** 手机号 */
  account?: string;
  /** 用户登录密码,MD5加密 */
  userPasswd?: string;
  /** 平台编码，详见数据库business_platform数据 */
  platformCode?: string;
  /** 验签类型 NULL SLIDER  */
  signType?: string;
  /** 滑块校验参数 ,SliderCheckParamForm */
  sliderParam?: any;
  /** 灰度平台，默认用户全平台灰度 */
  grayPlatform?: string;
};



export interface API45655Res {
  /** 用户id  */
  userId?: string;
  /** 业务id  */
  userName?: string;
  /** 真实姓名  */
  realName?: string;
  /** 用户头像地址  */
  headIcon?: string;
  /** 注册手机号  */
  userPhone?: string;
  /** 用户登录token  */
  userToken?: string;
  /** 是否灰度用户  */
  isGray?: boolean;
  /** 是否需要重置密码  */
  needReset?: boolean;
  /** 灰度配置内容，格式为json串  */
  grayParams?: string;
  
};


// 45655 账密登录

export interface IUsePostAPI45655Return {
  /** 账密登录: 接口请求状态 */
  isAPI45655Loading: boolean;
  /** 账密登录: 接口请求返回数据 */
  dataAPI45655: API45655Res;
  /**  账密登录: 接口数据请求方法 */
  fetchAPI45655Data:  (inputs: API45655Req, config?: YWRequestConfig) => Promise<API45655Res>;
  /** 账密登录: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI45655 = ():IUsePostAPI45655Return => {
  let isMount = true;
  const [isAPI45655Loading, setIsAPI45655Loading] = useState(false);
  const [dataAPI45655, setDataAPI45655] = useState<API45655Res>({} as API45655Res);
  const requestUrl = `${basePath}/ywwl-admin/business/user/account/login`;

  const fetchAPI45655Data = async (inputs: API45655Req, config?: YWRequestConfig): Promise<API45655Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API45655Req>) || {}) as API45655Req;
    
  
    if ( isMount ) {
      setIsAPI45655Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API45655Res>(`${basePath}/ywwl-admin/business/user/account/login`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI45655(res || {} as API45655Res);
        setIsAPI45655Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI45655Loading(false);
      }
      return false as unknown as API45655Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI45655Loading,
    dataAPI45655,
    fetchAPI45655Data,
    requestUrl,
  }
}

